export default "__VITE_ASSET__BirOL$lP__"